import styled from 'styled-components';

export const AppWrapper = styled.div`
  margin: 0;
  display: flex;
  min-height: 100%;
  flex-direction: column;
`;
